/* eslint-disable no-unused-vars */
import App from "./models/app";

export enum InstallStatus {
  INSTALL_FAILED = 'INSTALL_FAILED',
  INSTALL_STAGED = 'INSTALL_STAGED',
  NOT_INSTALLED = 'NOT_INSTALLED', // Client-only status
  ON_DEVICE = 'ON_DEVICE',
  PENDING_INSTALL = 'PENDING_INSTALL',
  PENDING_REMOVAL = 'PENDING_REMOVAL',
  PENDING_UPDATE = 'PENDING_UPDATE',
  UNKNOWN = 'UNKNOWN',
  UPDATE_AVAILABLE = 'UPDATE_AVAILABLE',
  UPDATE_FAILED = 'UPDATE_FAILED',
  UPDATE_STAGED = 'UPDATE_STAGED'
}

export enum InstallButtonState {
  DISABLED = 'DISABLED',
  INSTALLED = 'INSTALLED',
  NOT_INSTALLED = 'NOT_INSTALLED',
  UNINSTALL = 'UNINSTALL'
}

export enum OsPermissionStatus {
  // We have accepted the permission.
  DENIED = 'denied',
  // We have denied the permission.
  GRANTED = 'granted',
  // The current device doesn't have a feature that
  // supports this permission.
  UNAVAILABLE = 'unavailable',
  // Either we don't know what this permission is,
  // the OS doesn't know, or the current app
  // version doesn't support it.
  UNDETERMINED = 'undetermined'
}

export enum HasSettingsStatus {
  // The app has a Settings screen
  YES = 'yes',
  // The app has a Settings screen
  NO = 'no',
  // The app does not have companion
  NO_COMPANION = 'no-companion'
}

export enum CollectionType {
  COLLECTION = 'collection',
  CATEGORY = 'category'
}

export const roundEdgeDevices = ['versa 3', 'sense', 'versa 4', 'sense 2'];

export enum PageRoutes {
  HOME = 'HOME',
  MY_APPS = 'MY_APPS',
  GALLERY = 'GALLERY',
  SEARCH = 'SEARCH',
  COLLECTION = 'COLLECTION',
  APP = 'APP',
  PERMISSION = 'PERMISSION',
  OUTDATED = 'OUTDATED',
  ERROR = 'ERROR',

  // new/redesign routes
  MINE_V2 = 'MINE_V2',
  CLOCKS_V2 = 'CLOCKS_V2',
  APPS_V2 = 'APPS_V2',
  CLOCK_V2 = 'CLOCK_V2',
  MY_TILES_V2 = 'MY_TILES_V2',
  TILE_V2 = 'TILE_V2',
  GALLERY_V2_CLOCKS = 'GALLERY_V2_CLOCKS',
  GALLERY_V2_APPS = 'GALLERY_V2_APPS',
  GALLERY_V2_TILES = 'GALLERY_V2_TILES',
  DISCOVER_V2_APPS = 'DISCOVER_V2_APPS',
  DISCOVER_V2_CLOCKS = 'DISCOVER_V2_CLOCKS',
  DISCOVER_V2_TILES = 'DISCOVER_V2_TILES',
  COLLECTION_V2 = 'COLLECTION_V2',
  APP_V2 = "APP_V2",
  SEARCH_V2 = 'SEARCH_V2',
  SEARCH_ITEMS_V2 = 'SEARCH_ITEMS_V2',
  PERMISSION_V2 = 'PERMISSION_V2',
}

export enum RoutePaths {
  GALLERY_CLOCKS = '/v2/clocks/gallery',
  GALLERY_APPS = '/v2/apps/gallery',
  GALLERY_TILES = '/v2/tiles/gallery',
  DISCOVER_APPS = '/v2/apps/discover',
  DISCOVER_CLOCKS = '/v2/clocks/discover',
  DISCOVER_TILES = '/v2/tiles/discover',
  DEVICE = '/v2/device',
}

export enum AppType {
  APP = 'app',
  CLOCK = 'clock',
  SERVICE = 'service',
  TILE = 'tile'
}

export enum ItemLinkType {
  APP = 'APP',
  CATEGORY = 'CATEGORY',
  COLLECTION = 'COLLECTION',
  URL = 'URL',
}

export enum PageLayoutItemType {
  BANNER_LIST = 'BANNER_LIST',
  APP_LIST = 'APP_LIST',
  TILE_LIST = 'TILE_LIST',
  FLAT_APP_LIST = 'FLAT_APP_LIST',
}

export const maxTileNumber = 8;
export const minTileNumber = 2;
